<template>
  <div class="map-wrap">

    <div class="tab-loading" v-if="loading">
      <i class="fa fa-spinner fa-spin"></i> Loading configuration…
    </div>

    <template v-else>
      <form @submit.stop.prevent="onSubmit">

        <div class="form-group">
          <label>Browser Map Key <span class="req">*</span></label>
          <input type="text" class="field" v-model="browser_map_key"
            :class="{ 'field-err': errors['browser_map_key'] }"
            placeholder="AIza…" />
          <div class="field-hint">
            <i class="fa fa-info-circle"></i> Your Google Maps JavaScript API key. The key is validated against the Maps Geocoding API before saving.
          </div>
          <span v-if="errors['browser_map_key']" class="err-msg">{{ errors["browser_map_key"][0] }}</span>
        </div>

        <div class="form-group">
          <label>Map Search Radius <span class="req">*</span></label>
          <div class="unit-wrap" :class="{ 'unit-wrap-err': errors['map_search_radius'] }">
            <input type="number" class="unit-field" v-model="map_search_radius"
              placeholder="50" min="1" />
            <span class="unit-label">Miles</span>
          </div>
          <span v-if="errors['map_search_radius']" class="err-msg">{{ errors["map_search_radius"][0] }}</span>
        </div>

        <div class="form-footer">
          <button class="btn-save" type="submit" ref="kt_map_config_submit">
            <i class="fa fa-check"></i> Save
          </button>
        </div>

      </form>
    </template>

  </div>
</template>

<script>
import {
  FETCH_MAP_CONFIG,
  SUBMIT_MAP_CONFIG
} from "@/core/services/store/actions.type";

export default {
  data() {
    return {
      loading: true,
      browser_map_key: "",
      map_search_radius: 50,
      errors: [],
      id: 0
    };
  },
  created() {
    this.$store.dispatch(FETCH_MAP_CONFIG).then(data => {
      const d = data.data;
      this.browser_map_key    = d.browser_map_key    || "";
      this.map_search_radius  = d.map_search_radius  || 50;
      this.id                 = d.id                 || 0;
      this.loading = false;
    }).catch(() => { this.loading = false; });
  },
  methods: {
    onSubmit() {
      this.errors = [];
      const btn = this.$refs["kt_map_config_submit"];
      btn.disabled = true;
      btn.classList.add("spinner", "spinner-light", "spinner-right");

      const req = new XMLHttpRequest();
      req.open("GET",
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=27,80&key=" + this.browser_map_key,
        true
      );
      req.onreadystatechange = () => {
        if (req.readyState !== 4 || req.status !== 200) return;
        const da = JSON.parse(req.responseText);
        if (da.status === "OK") {
          this.$store.dispatch(SUBMIT_MAP_CONFIG, {
            browser_map_key:   this.browser_map_key,
            map_search_radius: this.map_search_radius,
            id_: this.id
          }).then(data => {
            if (this.id === 0) this.id = data.id;
            btn.classList.remove("spinner", "spinner-light", "spinner-right");
            btn.disabled = false;
            this.$toastr.s(data.msg);
          }).catch(err => {
            btn.classList.remove("spinner", "spinner-light", "spinner-right");
            btn.disabled = false;
            if (err.status) this.errors = err.data.msg;
            else this.$toastr.e(err.data.msg);
          });
        } else {
          btn.classList.remove("spinner", "spinner-light", "spinner-right");
          btn.disabled = false;
          this.$toastr.e(da.error_message || "Invalid API key");
        }
      };
      req.send();
    }
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$green:  #276749;
$dark:   #0d1b3e;
$border: #dde2ec;

.map-wrap { font-family: $font; }

.tab-loading {
  display: flex; align-items: center; gap: 10px;
  padding: 40px 0; color: #8a94a6; font-size: 13px;
  i { color: $blue; font-size: 18px; }
}

.form-group { margin-bottom: 20px; }

label {
  display: block;
  font-size: 11px; font-weight: 700;
  color: #4a5568;
  text-transform: uppercase; letter-spacing: 0.4px;
  margin-bottom: 6px;
}
.req { color: #e53e3e; }

.field {
  display: block; width: 100%;
  height: 38px;
  border: 1.5px solid $border; border-radius: 8px;
  padding: 0 12px;
  font-size: 13px; font-family: $font; color: $dark;
  background: #fff;
  transition: border-color 0.15s;
  box-shadow: none; outline: none;
  &:focus { border-color: $blue; }
  &.field-err { border-color: #e53e3e; }
}

.field-hint {
  margin-top: 6px; font-size: 11px; color: #8a94a6;
  display: flex; gap: 5px; align-items: flex-start;
  i { color: $blue; margin-top: 1px; }
}

/* Unit input */
.unit-wrap {
  display: flex;
  border: 1.5px solid $border; border-radius: 8px;
  overflow: hidden; width: 260px;
  transition: border-color 0.15s;
  &:focus-within { border-color: $blue; }
  &.unit-wrap-err { border-color: #e53e3e; }
}
.unit-field {
  border: none; flex: 1;
  height: 38px; padding: 0 12px;
  font-size: 13px; font-family: $font; color: $dark;
  outline: none; background: #fff;
  -moz-appearance: textfield;
  appearance: textfield;
  &::-webkit-inner-spin-button, &::-webkit-outer-spin-button { -webkit-appearance: none; appearance: none; }
}
.unit-label {
  display: flex; align-items: center;
  padding: 0 12px;
  background: #f7f9fc;
  border-left: 1.5px solid $border;
  font-size: 12px; font-weight: 600; color: #6b7280;
  white-space: nowrap;
}

.err-msg { font-size: 11px; color: #e53e3e; margin-top: 3px; display: block; }

.form-footer {
  display: flex; justify-content: flex-end;
  padding-top: 24px; margin-top: 8px;
  border-top: 1px solid #f0f3fa;
}

.btn-save {
  display: inline-flex; align-items: center; gap: 7px;
  height: 38px; padding: 0 24px; border-radius: 8px;
  border: none; background: $green;
  color: #fff; font-size: 13px; font-weight: 600; font-family: $font;
  cursor: pointer; transition: background 0.15s;
  i { font-size: 12px; }
  &:hover { background: #1d5230; }
  &:disabled { opacity: 0.6; cursor: default; }
}
</style>
